import { useState, useCallback } from "react";
import { notify } from "../../../utils/toast";

const STORAGE_KEY = "explore:selected_filter";

export function useExploreFilter(hasLastLo: boolean) {
  const [selectedFilter, setSelectedFilter] = useState<"all" | "nearby">(() => {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    if (!saved) {
      sessionStorage.setItem(STORAGE_KEY, "nearby");
      return "nearby";
    }
    return saved as "all" | "nearby";
  });

  const handleFilter = useCallback(
    (filter: "all" | "nearby"): boolean => {
      if (filter === "nearby" && !hasLastLo) {
        notify("내 위치를 먼저 설정해주세요!");
        return false;
      }
      setSelectedFilter(filter);
      sessionStorage.setItem(STORAGE_KEY, filter);
      sessionStorage.removeItem("explore:offset");
      sessionStorage.removeItem("explore:allReviews");
      sessionStorage.removeItem("explore:hasMore");
      return true;
    },
    [hasLastLo]
  );

  return { selectedFilter, setSelectedFilter, handleFilter };
}
